import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';

const STATUS = {
  BROUILLON: ['gray', 'Brouillon'],
  VALIDE: ['blue', 'Validée'],
  PUBLIE: ['green', 'Publiée'],
  CORRIGE: ['blue', 'Corrigée'],
  CLOTURE: ['gold', 'Clôturée'],
};

const TYPE = {
  CONTROLE: 'Contrôle',
  DEVOIR: 'Devoir',
  COMPOSITION: 'Composition',
  EXAMEN_BLANC: 'Examen blanc',
};

export default function Evaluations() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [groupByClass, setGroupByClass] = useState(false);

  useEffect(() => {
    api
      .get('/evaluations')
      .then(setRows)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  // Grouper par classe
  const grouped = rows.reduce((acc, e) => {
    const key = e.class?.name || 'Sans classe';
    if (!acc[key]) acc[key] = [];
    acc[key].push(e);
    return acc;
  }, {});
  const groupedEntries = Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b));

  const TableHead = () => (
    <thead>
      <tr>
        <th>Date</th>
        <th>Titre</th>
        <th>Type</th>
        <th>Matière</th>
        {!groupByClass && <th>Classe</th>}
        <th className="num">Barème</th>
        <th>Statut</th>
      </tr>
    </thead>
  );

  const EvalRow = ({ e }) => {
    const [cls, label] = STATUS[e.status] || ['gray', e.status];
    return (
      <tr className="clickable" onClick={() => navigate(`/evaluations/${e.id}`)}>
        <td className="mono">{new Date(e.date).toLocaleDateString('fr-FR')}</td>
        <td>{e.title}</td>
        <td>{TYPE[e.type] || e.type}</td>
        <td>{e.subject?.name}</td>
        {!groupByClass && <td>{e.class?.name}</td>}
        <td className="num">/{e.baremeTotal}</td>
        <td><span className={`badge ${cls}`}>{label}</span></td>
      </tr>
    );
  };

  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Évaluations</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className={`btn-ghost btn-sm${groupByClass ? ' active' : ''}`}
            onClick={() => setGroupByClass((v) => !v)}
            style={groupByClass ? { background: 'var(--primary-soft, #eff6ff)', color: 'var(--primary, #1d4ed8)', borderColor: 'var(--primary, #1d4ed8)' } : {}}
          >
            Par classe
          </button>
          <button className="btn-ghost btn-sm" onClick={() => navigate('/pedagogie/rapports')}>Rapports</button>
          <button className="btn-ghost btn-sm" onClick={() => navigate('/pedagogie/parametres')}>Paramètres</button>
          <button className="btn btn-sm" onClick={() => navigate('/evaluations/new')}>+ Nouvelle évaluation</button>
        </div>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {loading ? (
          <div className="loading">Chargement…</div>
        ) : rows.length === 0 ? (
          <div className="empty">Aucune évaluation. Crée-en une pour commencer.</div>
        ) : groupByClass ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            {groupedEntries.map(([className, evals]) => (
              <div key={className}>
                <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', marginBottom: 6, paddingBottom: 4, borderBottom: '1px solid var(--line)' }}>
                  {className} <span style={{ fontWeight: 400 }}>({evals.length})</span>
                </div>
                <div className="table-wrap">
                  <table>
                    <TableHead />
                    <tbody>{evals.map((e) => <EvalRow key={e.id} e={e} />)}</tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="table-wrap">
            <table>
              <TableHead />
              <tbody>{rows.map((e) => <EvalRow key={e.id} e={e} />)}</tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
